<template>
	<div>
		<v-card v-if="userisconfirmed" class="mx-auto elevation-1" style="max-width: 500px" :loading="apiRequest">
			<v-card-title class="pa-5 text-center headline font-weight-black">
				<v-spacer />Sign In
				<v-spacer />
			</v-card-title>
			<v-card-subtitle v-if="loginerror" class="text-center red--text">Error Logging in. Please check your username/password.</v-card-subtitle>
			<v-card-text v-if="!newPasswordRequired">
				<v-form ref="signinform" v-model="valid" lazy-validation>
					<v-text-field v-model="email" label="E-mail" type="text" outlined :rules="emailRules" required />
					<v-text-field
						id="password"
						v-model="password"
						:append-icon="showpassword ? 'mdi-eye' : 'mdi-eye-off'"
						:type="showpassword ? 'text' : 'password'"
						name="password"
						label="Password"
						:counter="password.length > 0"
						outlined
						:rules="passwordRules"
						required
						@click:append="showpassword = !showpassword"
					/>
				</v-form>
			</v-card-text>
			<v-card-text v-if="newPasswordRequired">
				<v-form ref="signinform" v-model="valid" lazy-validation>
					<v-text-field v-model="email" label="E-mail" type="text" outlined :rules="emailRules" required />
					<v-text-field
						id="password"
						v-model="password"
						label="Password"
						outlined
						:type="showpassword ? 'text' : 'password'"
						:append-icon="showpassword ? 'mdi-eye' : 'mdi-eye-off'"
						required
						name="password"
						:rules="passwordRules"
						@click:append="showpassword = !showpassword"
					></v-text-field>

					<v-card-subtitle class="text-center red--text">You are using a temporary password. Please provide your new password and click sign in.</v-card-subtitle>

					<v-text-field
						id="confirmpassword"
						v-model="confirmpassword"
						label="New Password"
						:rules="[...passwordRules, passwordConfirmationRule]"
						outlined
						:type="showpassword ? 'text' : 'password'"
						:append-icon="showpassword ? 'mdi-eye' : 'mdi-eye-off'"
						name="confirmpassword"
						required
						@click:append="showpassword = !showpassword"
					></v-text-field>
				</v-form>
			</v-card-text>
			<v-card-actions>
				<v-spacer />
				<v-btn class="mb-2 pa-1 text-none" :loading="apiRequest" :disabled="!valid" width="200px" x-large rounded color="primary" @click="signIn"
					>Sign In
					<!-- <v-icon right>mdi-arrow-right</v-icon> -->
				</v-btn>

				<v-spacer />
			</v-card-actions>
		</v-card>

		<!--user-confirm-signup-form v-if="!userisconfirmed"></user-confirm-signup-form-->
		<!-- end confirm signup form -->
	</div>
</template>

<script>
import { Auth } from 'aws-amplify';
import { AmplifyEventBus } from 'aws-amplify-vue';
import store from '@/store';
import { Tracking } from '@/utils/tracking';
//import UserConfirmSignupForm from "@/components/user/UserConfirmSignupForm.vue";

export default {
	name: 'UserSignInForm',
	components: {
		//UserConfirmSignupForm
	},

	data: () => ({
		valid: false,

		userisconfirmed: true,
		showpassword: false,
		showconfirmpassword: false,

		loginerror: false,

		password: '',
		confirmpassword: null,
		apiRequest: false,

		name: '',
		email: '',
		checkbox: false,

		//confirm
		loading: false,
		confirmcode: '',

		confirmsignupError: false,

		confirmcoderesent: true,
		resendConfirmCodeError: false,

		newPasswordRequired: false,

		rules: {
			email: v => (v || '').match(/@/) || 'Please enter a valid email',
			length: len => v => (v || '').length >= len || `Invalid character length, required ${len}`,
			password: v =>
				(v || '').match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*(_|[^\w])).+$/) || 'Password must contain an upper case letter, a numeric character, and a special character',

			//
			confirmpassword: v =>
				(v || '').match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*(_|[^\w])).+$/) ||
				'Confirm Password must contain an upper case letter, a numeric character, and a special character',
			//
			required: v => !!v || 'This field is required',
		},

		passwordRules: [
			v => !!v || 'Password is required',
			v => (v && v.length >= 5) || 'Password must have 5+ characters',
			v => /(?=.*[A-Z])/.test(v) || 'Must have one uppercase character',
			v => /(?=.*\d)/.test(v) || 'Must have one number',
			//v => /([!@$%])/.test(v) || 'Must have one special character [!@#$%]'
		],
	}),

	computed: {
		passwordConfirmationRule() {
			return this.password !== this.confirmpassword || 'Password can not be same as temporary password.';
		},

		emailRules() {
			return [v => !!v || 'E-mail is required', v => /.+@.+/.test(v) || 'E-mail must be valid'];
		},
	},
	mounted() {
		Tracking.track('DisplaySignin', {});

		const { email } = this.$route.query;
		if (email) {
			this.email = email;
		}
	},
	methods: {
		async signIn() {
			// eslint-disable-next-line no-unused-vars

			if (this.$refs.signinform.validate()) {
				this.loginerror = false;
				this.apiRequest = true;
				let password = this.password;
				let email = this.email.toLowerCase().trim();
				Auth.signIn(email, password)
					.then(user => {
						const tenant = user?.attributes?.['custom:tenant'];
						if (tenant) {
							store.commit('SET_TENANT', tenant);
						}
						Tracking.track('Signin', { email });
						Tracking.updateMixpanel();
						if (user.challengeName === 'NEW_PASSWORD_REQUIRED' && !this.newPasswordRequired) {
							console.info('ask for new password', user);
							this.newPasswordRequired = true;
							this.apiRequest = false;
						} else if (user.challengeName === 'NEW_PASSWORD_REQUIRED' && this.newPasswordRequired) {
							console.info('submit new password', user, this.confirmpassword);
							this.newPasswordRequired = false;
							this.apiRequest = false;
							Auth.completeNewPassword(
								user, // the Cognito User Object
								this.confirmpassword // the new password
							)
								.then(user => {
									// at this time the user is logged in if no MFA required
									console.info('temp password signing in response', user);
									AmplifyEventBus.$emit('authState', 'signedIn');
									console.info('logged in user', user);
									this.apiRequest = false;
									// this.$router.push("/dashboard");
								})
								.catch(error => {
									this.loginerror = true;
									console.info('error temp password signing in', error);
								});
						} else {
							AmplifyEventBus.$emit('authState', 'signedIn');
							console.info('logged in user', user);
							this.apiRequest = false;
							// this.$router.push("/dashboard");
						}
					})
					.catch(error => {
						if (error.code == 'UserNotConfirmedException') {
							//need to send to confirm code page ?
							// or  reveal it
							this.apiRequest = false;

							//this.userisconfirmed=false;
							//send user to confirm signup
							this.$router.push('/confirm-signup');
						} else if (error.code === 'PasswordResetRequiredException') {
							console.info('user requires password reset', error);
							store.commit('SET_USERNAME', email);
							this.$router.push({ path: '/reset-password', query: { username: email } });
						} else {
							this.apiRequest = false;
							this.loginerror = true;
							console.error('error signing in', error);
						}
					});
			} //end validate
		},
	},
};
</script>
